import { createSlice } from "@reduxjs/toolkit"
import { bulkEditAssociationsUrl, bulkEditPreviewUrl, bulkEditProcessImportUrl, bulkEditTemplatesUrl } from "../../lib/endpoints"
import client from "../../lib/client"

export const bulkEditSlice = createSlice({
    name: "bulkEdit",
    initialState: {
        filters: {},
        previewValues: [],

        // These should all probably be grouped up into a single object... //
        
        divisions: [],
        vendors: [],
        supplyAccounts: [],
        billableAccounts: [],
        meterNumbers: [],
        facilities: [],
        ledgerAccounts: [],
        ledgerFields: [],
        utilityServices: [],

        //////////////////////////////////////////////

        total: 0,
        pagination: { current: 1, pageSize: 10 },
        loading: false,
    },
    reducers: {
        setDivisions: (state, action) => {
            state.divisions = action.payload.divisions
        },
        setVendors: (state, action) => {
            state.vendors = action.payload.vendors
        },
        setSupplyAccounts: (state, action) => {
            state.supplyAccounts = action.payload.supply_accounts
        },
        setBillableAccounts: (state, action) => {
            state.billableAccounts = action.payload.billable_accounts
        },
        setMeterNumbers: (state, action) => {
            state.meterNumbers = action.payload.meter_numbers
        },
        setFacilities: (state, action) => {
            state.facilities = action.payload.facilities
        },
        setLedgerAccounts: (state, action) => {
            state.ledgerAccounts = action.payload.ledger_accounts
        },
        setLedgerFields: (state, action) => {
            state.ledgerFields = action.payload.ledger_fields
        },
        setUtilityServices: (state, action) => {
            state.utilityServices = action.payload.utility_services
        },
        setPreviewValues: (state, action) => {
            state.previewValues = action.payload.preview_vals
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
    },
})


export const {
    setDivisions,
    setLoading,
    setVendors,
    setSupplyAccounts,
    setBillableAccounts,
    setMeterNumbers,
    setFacilities,
    setLedgerAccounts,
    setLedgerFields,
    setUtilityServices,
    setPreviewValues,
} = bulkEditSlice.actions

export function getAssociations(clientId, type){
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        const res = await client.get(`${bulkEditAssociationsUrl(clientId)}?type=${type}`)
        const { result } = res.data

        // console.log(result)

        dispatch(setDivisions(result))
        dispatch(setVendors(result))
        dispatch(setSupplyAccounts(result))
        dispatch(setBillableAccounts(result))
        // dispatch(setMeterNumbers(result))
        dispatch(setFacilities(result))
        dispatch(setLedgerAccounts(result))
        dispatch(setLedgerFields(result))
        dispatch(setUtilityServices(result))

        dispatch(setLoading(false))
    }
}

// A slow preview can come back after the user has moved on to another type; only the latest request may land.
let latestPreviewRequest = 0

export function clearPreview() {
    return (dispatch) => {
        latestPreviewRequest++
        dispatch(setPreviewValues({ preview_vals: [] }))
    }
}

export function getPreview(clientId, type, blank){
    return async (dispatch, getState) => {
        const request = ++latestPreviewRequest
        dispatch(setLoading(true))
        try {
            const res = await client.get(`${bulkEditPreviewUrl(clientId)}?type=${type}&blank=${blank}&connection_id=${getState().app.uid}`)
            // console.log(res)
            if (request === latestPreviewRequest) dispatch(setPreviewValues(res.data))
        } finally {
            dispatch(setLoading(false))
        }
    }
}

export function getTemplate(clientId, type, blank){
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        const res = await client.get(`${bulkEditTemplatesUrl(clientId)}?type=${type}&blank=${blank}&connection_id=${getState().app.uid}`).catch((e) => {
            console.log("ERROR", e)
            dispatch(setLoading(false))
        })
        dispatch(setLoading(false))
    }
}

export function processImport(clientId, type, file){
    return async (dispatch, getState) => {
        dispatch(setLoading(true))
        const fmData = new FormData()
        fmData.append("file", file)
        fmData.append("connection_id", getState().app.uid)
        try {
            const response = await client.post(`${bulkEditProcessImportUrl(clientId)}?type=${type}`, fmData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            dispatch(setLoading(false))
        } catch (err) {
            console.log("Error: ", err)
            dispatch(setLoading(false))
        }
    }
}

export const selectDivisions = (state) => state.bulkEdit.divisions
export const selectVendors = (state) => state.bulkEdit.vendors
export const selectSupplyAccounts = (state) => state.bulkEdit.supplyAccounts
export const selectBillableAccounts = (state) => state.bulkEdit.billableAccounts
export const selectMeterNumbers = (state) => state.bulkEdit.meterNumbers
export const selectFacilities = (state) => state.bulkEdit.facilities
export const selectLedgerAccounts = (state) => state.bulkEdit.ledgerAccounts
export const selectLedgerFields = (state) => state.bulkEdit.ledgerFields
export const selectUtilityServices = (state) => state.bulkEdit.utilityServices
export const selectPreviewValues = (state) => state.bulkEdit.previewValues

export const selectTotal = (state) => state.bulkEdit.total
export const selectPagination = (state) => state.bulkEdit.pagination
export const selectLoading = (state) => state.bulkEdit.loading


export default bulkEditSlice.reducer